import { gql } from '@apollo/client';

export const GET_SERVICES_POPULARITY_INSIGHTS = gql`
  query getServicesPopularityInsights($dataScope: DataScope!, $locationId: ID!, $startAt: ISO8601DateTime!, $endAt: ISO8601DateTime!) {
    servicesPopularityInsights(dataScope: $dataScope, locationId: $locationId, startAt: $startAt, endAt: $endAt) {
      leastBooked {
        id
        count
        totalPrice
      }
      mostBooked {
        id
        count
        totalPrice
      }
      others {
        id
        count
        totalPrice
      }
      services {
        id
        count
        totalPrice
      }
    }
  }
`;
